/* ========================================================================
   On document ready do stuff
 ========================================================================== */

util.onDocumentReady(function () {
  const body = document.getElementById('body');

  // Set frontend version
  util.frontEndVersion = body.dataset.version;

  // Set debug mode
  util.debugMode = body.dataset.debugMode === 'true';

  // Set culture
  util.uiCulture = body.dataset.culture;

  // Set language
  util.uiLanguage = util.uiCulture ? util.uiCulture.split('-')[0] : null;

  // Set homepage Id
  util.homePageId = body.dataset.homepageId;

  // Set path
  util.path = body.dataset.path;

  if (util.debugMode) {
    console.info(util.uiCulture, util.uiLanguage, util.homePageId, util.path);
    if (!util.uiCulture) console.error('Culture is not set');
    if (!util.uiLanguage) console.error('Language is not set');
    if (!util.homePageId) console.error('HomePageId is not set');
    if (!util.path) console.error('Path is not set');
  }

  // Enable transitions
  document.documentElement.classList.remove('is-loading');

  // Enable SVG in IE11
  // svg4everybody();

  app.general.initAppHeight();
  // app.general.initAnchorLinks();
  app.navigation.init();
  app.navMobile.init();
  // app.navigation.initSearchBox();
  app.general.initEmailLinks();
  // app.general.initLax();
  app.cookiePopup.init();
  app.dataLayer.init();

  const min = util.debugMode === false ? '.min' : '';

  if (document.querySelectorAll('[data-toast-message]').length > 0) {
    // show toast messages (with delay)
    const toastMessages = document.querySelectorAll('[data-toast-message]');
    toastMessages.forEach((message, index) => {
      window.setTimeout(() => {
        Toast(message.innerHTML, message.dataset.toastType.toLowerCase(), message.dataset.toastTimeout ?? 7500);
      }, index * 1000);
    });
  }

  if (document.querySelectorAll('[data-accordion-list]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.accordion' + min + '.js'), () => {
      app.accordion.init();
    });
  }

  if (
    document.querySelectorAll('[data-carousel]').length > 0 ||
    document.querySelectorAll('[data-hero-carousel]').length > 0 ||
    document.querySelectorAll('[data-logo-carousel]').length > 0 ||
    document.querySelectorAll('[data-tabs-carousel]').length > 0
  ) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/embla' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/embla-carousel-autoplay' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.carousel' + min + '.js'),
      () => {
        app.carousel.init();
      }
    );
  }

  if (document.querySelectorAll('[data-video]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.videos' + min + '.js'), () => {
      app.videos.init();
    });
  }

  if (document.querySelectorAll('[data-video-lightbox]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/videoLightbox' + min + '.js'), () => {
      const videos = document.querySelectorAll('[data-video-lightbox]');
      const lightbox = VideoLightbox(videos);

      document.addEventListener('cookieconsent_update', () => {
        if (util.hasCookieConsent('marketing')) {
          lightbox.removeConsentWarning();
        }
      });
    });
  }

  if (document.querySelector('.searchResults')) {
    if (document.location.href.indexOf('?') > -1) {
      setTimeout(() => {
        document.querySelector('[data-results-anchor]').scrollIntoView({
          behavior: 'smooth',
        });
      }, 500);
    }
  }

  if (document.querySelectorAll('[data-info-block]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/matchheight' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.infoBlocks' + min + '.js'),
      () => {
        app.infoBlocks.init();
      }
    );
  }

  if (document.querySelectorAll('[data-info-grid]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.infoBlocksGrid' + min + '.js'), () => {
      app.infoBlocksGrid.init();
    });
  }

  ljs.load(util.getVersionedUrl('/scripts/dist/forms.newsletter' + min + '.js'), () => {
    // Load aspnet-validation if not loaded yet
    // Use a delay to make sure it doesn't conflict with Umbraco Forms' version of aspnet-validation
    window.setTimeout(() => {
      if (typeof window.aspnetValidation !== 'object') {
        ljs.load(
          '/scripts/dist/aspnet-validation.min.js',
          util.getVersionedUrl('/scripts/dist/forms.validation.min.js'),
          () => {}
        );
      }
    }, 2000);
  });

  if (document.querySelectorAll('[data-project-listing]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.projectListing' + min + '.js'), () => {
      app.projectListing.init();
    });
  }

  if (document.querySelectorAll('[data-partners]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.partnerListing' + min + '.js'), () => {
      app.partnerListing.init();
    });
  }

  if (document.querySelectorAll('[data-generic-form]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.generic' + min + '.js'),
      () => {
        app.genericForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-popup]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.popup' + min + '.js'), () => {
      app.popup.init();
    });
  }

  if (document.querySelectorAll('[data-sticky-element]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/sticky.compile' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.stickyElements' + min + '.js'),
      () => {
        // var sticky = new Sticky('[data-sticky-element]');
        app.stickyElements.init();
      }
    );
  }
});
